module.exports = __webpack_public_path__ + "static/media/pf.1c09f581.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/pf.svg
// module id = 220
// module chunks = 0